import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=87bc3a30"
import script from "./CompanyList.js?vue&type=script&lang=js&external"
export * from "./CompanyList.js?vue&type=script&lang=js&external"
import style0 from "./CompanyList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports